import { render, staticRenderFns } from "./AssociatedFarms.vue?vue&type=template&id=6633f1cd&scoped=true"
import script from "./AssociatedFarms.vue?vue&type=script&lang=js"
export * from "./AssociatedFarms.vue?vue&type=script&lang=js"
import style0 from "./AssociatedFarms.vue?vue&type=style&index=0&id=6633f1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633f1cd",
  null
  
)

export default component.exports